import React from 'react';

const links = [
  {href: '/', label: '計分板'},
  {href: '/how-to-use/', label: '使用教學'},
  {href: '/badminton-rules/', label: '計分規則'},
  {href: '/faq/', label: '常見問題'},
  {href: '/about/', label: '關於'},
  {href: '/privacy/', label: '私隱'}
];

const SiteNav = ({compact = false}) => (
  <nav
    aria-label="網站內容導覽"
    className={`flex flex-wrap ${compact ? 'gap-1.5' : 'gap-2'}`}
  >
    {links.map(link => (
      <a
        key={link.href}
        href={link.href}
        className="rounded-xl border border-white/10 bg-white/[0.05] px-3 py-2 text-xs font-black text-white/60 transition-all hover:border-indigo-400/40 hover:bg-white/[0.09] hover:text-white focus:outline-none focus:ring-2 focus:ring-indigo-400"
      >
        {link.label}
      </a>
    ))}
  </nav>
);

export default SiteNav;